<div (clickOutside)="menu.hide();" class="actions-container">
    <acengage-button [isNgContentAdded]="true" [isBtnDisable]="(isCheckSelectedRow && !selectedTableRows.length) || disableActionButton || (multipleRowsSelected  && selectedTableRows.length >1)"
        [buttonText]="'Actions'" [iconDtls]="{name: 'pi pi-caret-down', position: 'right'}"
        (buttonClicked)="menu.toggle($event);">
    </acengage-button>
    <div #menuContainer></div>
    <p-menu styleClass="custom-menu" #menu [popup]="true" [model]="items" appendTo="menuContainer">
    </p-menu>
</div>